import { floorDate } from './date-rounding'

export function isSameMonth(dateA: Date | string | null, dateB: Date | string | null) {
  if (dateA === null || dateB === null) return false

  const normalizedDateA = new Date(dateA)
  const normalizedDateB = new Date(dateB)

  return (
    floorDate(normalizedDateA, { unit: 'month' }).getTime() === floorDate(normalizedDateB, { unit: 'month' }).getTime()
  )
}
